import { Box, Flex, Image } from '@chakra-ui/react';
import React from 'react';

export default function CustomSpinner() {
  return (
    <Flex minH="100vh" align="center" justify="center" position="fixed" top="0" right="0" bottom="0" left="0" zIndex="200">
      <Box>
        <Image
          className="lazyload"
          width="110px"
          objectFit="cover"
          src="/assets/icons/packman.gif"
          alt="Flate"
          ml={{
            base: '8px',
            md: '0',
          }}
        />
      </Box>
    </Flex>
  );
}
